<form *ngIf="contractCapabilityFormGroup" [formGroup]="contractCapabilityFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="capabilityId">Especialidad</label>
           <!-- <p-dropdown [options]="capabilities" formControlName="capabilityId" [required]="true" optionValue="id"
                [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione especialidad" appendTo="body"
                d-form-field-error />-->
            <p-multiSelect [ngModelOptions]="{standalone: true}" [options]="capabilities" [(ngModel)]="selectedCapabilitiesIds" 
                placeholder="Todos" optionLabel="name" display="chip" appendTo="body"  (onFilter)="load($event)" placeholder="Seleccione especialidades"
                [maxSelectedLabels]="selectedCapabilitiesIds!=null?selectedCapabilitiesIds.length:5"
                showClear>
                 
            </p-multiSelect>
        </div> 

        <div class="col-4 input-field">
            <label for="normalServiceAllowed" class="mr-1">Horario normal</label>
            <p-inputSwitch id="normalServiceAllowed" formControlName="normalServiceAllowed" d-form-field-error></p-inputSwitch>
        </div>
        <div class="col-4 input-field">
            <label for="guardServiceAllowed" class="mr-1">Horario de guardia</label>
            <p-inputSwitch id="guardServiceAllowed" formControlName="guardServiceAllowed" d-form-field-error></p-inputSwitch>
        </div>    
           
        <div class="col-4 input-field">
            <label for="guardPercentIncrement">% Incremento por guardia</label>
            <input id="guardPercentIncrement" formControlName="guardPercentIncrement" pInputText type="number" d-form-field-error/>
        </div>    
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && contractCapability.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
            (click)="save()"></p-button>
    </div>

</form>

